import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { ButtonProps } from '@mui/material';
import { usePalette } from 'src/hooks';
import { Button } from 'src/components/atoms';

interface Props extends ButtonProps {
  children?: ReactNode;
  loading?: boolean;
}

// Style for both Myme editor and Blobs editor
export const StyledFormActions = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 1rem 0;
`;

// Component for both Myme editor and Blobs editor
export const EditorStepActionButton = ({ children, sx, ...props }: Props) => {
  const { primary } = usePalette();

  return (
    <Button
      type='submit'
      sx={{
        backgroundColor: primary.main,
        height: 'fit-content',
        padding: '0.75rem 1rem',
        textTransform: 'none',
        ...sx
      }}
      {...props}
    >
      {children}
    </Button>
  );
};
